const PREFIX = "pilcore.manufacturing.pending.v1";
const UUID = /^[\da-f]{8}-[\da-f]{4}-4[\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/i;
const positiveId = (value) => typeof value === "number" && Number.isSafeInteger(value) && value > 0;
const storageError = () => Object.assign(new Error("The pending manufacturing could not be recovered safely. Reload this page after checking browser storage."), { code: "MANUFACTURING_PENDING_STORAGE" });
export function manufacturingPendingKey(userId, businessUnitId) {
  if (!positiveId(Number(userId)) || !positiveId(Number(businessUnitId))) throw storageError();
  return `${PREFIX}:${Number(userId)}:${Number(businessUnitId)}`;
}
function validPayload(value) {
  if (!value || Array.isArray(value) || Object.keys(value).sort().join(",") !== "idempotency_key,location_id,movement_date,notes,quantity,recipe_id") return false;
  const date = value.movement_date;
  return positiveId(value.recipe_id) && positiveId(value.location_id) && typeof value.quantity === "number" &&
    Number.isFinite(value.quantity) && value.quantity > 0 && value.quantity < 1e10 && Number(value.quantity.toFixed(8)) > 0 &&
    typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date) && Number.isFinite(Date.parse(date)) && new Date(date).toISOString().slice(0, 10) === date &&
    (value.notes === null || (typeof value.notes === "string" && value.notes.length <= 2000)) && typeof value.idempotency_key === "string" && UUID.test(value.idempotency_key);
}
export function readManufacturingPending(userId, businessUnitId) {
  try {
    const raw = window.sessionStorage.getItem(manufacturingPendingKey(userId, businessUnitId));
    if (raw === null) return null;
    if (raw.length > 10000) throw storageError();
    const stored = JSON.parse(raw);
    if (!stored || stored.version !== 1 || stored.user_id !== Number(userId) || stored.business_unit_id !== Number(businessUnitId) || !validPayload(stored.payload)) throw storageError();
    return stored.payload;
  } catch (_) { throw storageError(); }
}
export function saveManufacturingPending(userId, businessUnitId, payload) {
  try {
    if (!validPayload(payload)) throw storageError();
    const previous = readManufacturingPending(userId, businessUnitId);
    if (previous && JSON.stringify(previous) !== JSON.stringify(payload)) throw storageError();
    window.sessionStorage.setItem(manufacturingPendingKey(userId, businessUnitId), JSON.stringify({ version: 1, user_id: Number(userId), business_unit_id: Number(businessUnitId), payload }));
  } catch (_) { throw storageError(); }
}
export function clearManufacturingPending(userId, businessUnitId, payload) {
  try {
    const previous = readManufacturingPending(userId, businessUnitId);
    if (previous && JSON.stringify(previous) === JSON.stringify(payload)) window.sessionStorage.removeItem(manufacturingPendingKey(userId, businessUnitId));
  } catch (_) { throw storageError(); }
}
